/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const ResourceKind: core.serialization.ObjectSchema<serializers.ResourceKind.Raw, Truvity.ResourceKind> =
    core.serialization.object({
        name: core.serialization.string(),
        version: core.serialization.number(),
    });

export declare namespace ResourceKind {
    export interface Raw {
        name: string;
        version: number;
    }
}
